import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { environment } from 'src/environments/environment'
import { SmartQuoteTemplate } from 'src/app/shared/interfaces/smartquote-template/smartquote-template.interface'

@Injectable({
    providedIn: 'root',
})
export class SmartQuoteTemplateService {
    constructor(private httpClient: HttpClient) {}

    getSmartQuoteTemplates(): Observable<SmartQuoteTemplate[]> {
        return this.httpClient
            .get<ApiResponse<SmartQuoteTemplate[]>>(`${environment.baseUrl}SmartQuoteTemplate`)
            .pipe(map((x) => x.result))
    }
}
